// extracted by mini-css-extract-plugin
export default {"root":"_4z_mD5Vn","item":"_2KNl4SKq","center":"_2sTZ_mVy","right":"_17fEb9d_","left":"TS0sTM8H","bordered":"_1tGOrLRK"};